import { receiveBranchInvoice } from 'redevConfig'

const list = (receiveBranchInvoice && receiveBranchInvoice.list) || ''
const receiveBranchInvoiceList = list ? require(`redevelopment/outputManage/receiveBranchInvoice/${list.templateName}`) : require('./views/receiveBranchInvoiceList.html')
function routerConf ($stateProvider) {
    // 'ngInject';
    $stateProvider
        .state('outputManage.stock.receiveBranchInvoice',
            {
                url: '/receiveBranchInvoice',
                template: '<div ui-view></div>',
                abstract: true,
                // controller: 'receiveBranchInvoiceCtrl',
                title: '分机领票',
                default: 'outputManage.stock.receiveBranchInvoice.list',
            })
        .state('outputManage.stock.receiveBranchInvoice.list', {
            url: '/list',
            template: receiveBranchInvoiceList,
            controller: 'receiveBranchInvoiceListCtrl',
        })
}
export default routerConf



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/receiveBranchInvoice/Routers.js